import React from 'react';

import TertiaryButton from '@modules/common/components/buttons/TertiaryButton';
import BaseModal from '@modules/common/components/BaseModal';

import { ILogout } from '../../actions/auth';
import { alertError, alertSuccess } from '../../lib/alert';
import { ApiError, getMessageFromApiError } from '../../lib/api';
import SentryUtils from '../../lib/sentry';
import UserResource from '../../services/Identity/UserResource';
import DeleteUser from './DeleteUser';

type Props = {
  logout: () => Promise<ILogout>;
  userId: string;
};

const initialState = Object.freeze({
  deleting: false,
});

type State = typeof initialState;

class DeleteUserContainer extends React.PureComponent<Props> {
  readonly state: State = initialState;

  handleDelete = () => {
    if (this.state.deleting) {
      return;
    }

    this.setState({ deleting: true });

    UserResource.delete({ userId: this.props.userId })
      .then(this.handleUserDeleted)
      .catch(this.handleUserDeletionError);
  };

  handleUserDeleted = () => {
    this.props.logout();
    alertSuccess('User successfully delete!');
  };

  handleUserDeletionError = (apiError: ApiError<any>) => {
    const errorMessage = 'Something went wrong while deleting user.';
    alertError(getMessageFromApiError(apiError, errorMessage));
    this.setState({ loading: false });
    SentryUtils.captureAPIError(apiError, errorMessage);
  };

  renderTrigger = (handleOpen: () => void) => {
    return (
      <TertiaryButton content="Delete Profile" onClick={handleOpen} style={{ textAlign: 'left' }} />
    );
  };

  render() {
    const { deleting } = this.state;
    return (
      <BaseModal trigger={this.renderTrigger}>
        {handleClose => (
          <DeleteUser
            handleClose={handleClose}
            deleting={deleting}
            handleDelete={this.handleDelete}
          />
        )}
      </BaseModal>
    );
  }
}

export default DeleteUserContainer;
